import config from '../config'

/**
 * priceStr
 * @param price - The price to format
 * @action - Format a price into a string
 * @returns price - The formatted price
 */
export default function priceStr(price: number | string) {
  // If price is a string, convert it to a number
  const priceInt = typeof price === 'string' ? parseFloat(price) : price
  // If the price is less than 0.01, show 3 decimal places, otherwise show 2
  const maximumFractionDigits = priceInt < 0.01 ? 3 : 2
  // If the locale is French, use Swiss German instead
  const locale = config.i18n.locale === 'fr-CH' ? 'de-CH' : config.i18n.locale
  // Return the formatted price
  return priceInt.toLocaleString(locale, {
    style: 'currency',
    currencyDisplay: 'symbol',
    currency: config.i18n.currency_ISO,
    maximumFractionDigits: maximumFractionDigits
  })
}
